import { Box, Card, Grid, Typography, Button, Modal, Snackbar, Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { useDropzone } from 'react-dropzone';
import { useParams } from 'react-router-dom';
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
import { apipost } from '../../service/api';

const Efolder = ({ data, userAction, loanData }) => {
    const [efolderData, setEfolderData] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [docusignUrl, setDocusignUrl] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const params = useParams();
    const userid = localStorage.getItem('user_id');

    useEffect(() => {
        if (data) {
            // Restructure data to separate attachments into their own rows
            const restructuredData = [];
            data.forEach((document) => {
                restructuredData.push({ ...document, isAttachment: false });
                document.attachments.forEach((attachment) => {
                    restructuredData.push({ ...attachment, parentId: document.documentId, isAttachment: true });
                });
            });
            setEfolderData(restructuredData);
        }
    }, [data, userAction]);

    const handleOpen = (documentId) => {
        setSelectedId(documentId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFiles([]);
    };

    const onDrop = (acceptedFiles) => {
        setFiles(acceptedFiles);
    };

    const handleUpload = async () => {
        if (files.length === 0) {
            console.error('No files selected for upload.');
            setSnackbarMessage('No files selected for upload.');
            setSnackbarOpen(true);
            return;
        }

        const file = files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('documentId', selectedId);
        formData.append('userid', userid);

        setLoadingUpload(true);

        try {
            const response = await apipost(`loan/upload/${params.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log('Upload successful:', response);
            handleClose();
        } catch (error) {
            console.error('Error uploading file:', error);
            setSnackbarMessage(`Error uploading file: ${error.response?.data?.details || error.message}`);
            setSnackbarOpen(true);
        } finally {
            setLoadingUpload(false);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    const handleDocuSign = async (attachment) => {
        console.log('Attachment object:', attachment.entityId);
        console.log('Loan data object:', loanData);
        const attachmentId = attachment.entityId;

        setLoading(true);

        try {
            console.log(`Attachment ID is ${attachmentId}`);
            const response = await apipost(`loan/docusign/${params.id}`, {
                attachmentId,
                email: loanData['1240'],
                firstName: loanData['4000'], // Assuming '4000' corresponds to first name
                lastName: loanData['4002'], // Assuming '4002' corresponds to last name
                createdBy: userid,
            });

            if (response && response.data && response.data.docusignUrl) {
                setDocusignUrl(response.data.docusignUrl);
            } else {
                console.error('DocuSign URL not found in response.');
            }

            console.log('DocuSign request successful:', response);
        } catch (error) {
            console.error('Error sending DocuSign request:', error);
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setDocusignUrl(null);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const columns = [
        {
            field: 'info',
            headerName: 'Document Information',
            flex: 1,
            renderCell: (params) => {
                if (params.row.isAttachment) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <Typography variant="body2" style={{ flex: 1 }}>{params.row.entityName}</Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => handleDocuSign(params.row)}
                                style={{ marginLeft: '10px' }}
                            >
                                Send by DocuSign
                            </Button>
                        </div>
                    );
                }  
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <Typography variant="body2" style={{ flex: 1 }}>{params.row.title}</Typography>
                            <Typography variant="body2" style={{ flex: 1 }}>{params.row.status}</Typography>
                            <Typography variant="body2" style={{ flex: 1 }}>{moment(params.row.createdDate).format('MM/DD/YYYY')}</Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleOpen(params.row.documentId)}
                            >
                                Upload
                            </Button>
                        </div>
                    );
                }
            }
        
    ];

    return (
        <div>
            <Grid item xs={12} sm={12}>
                <Typography variant="h4">Document Information</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Card style={{ height: 400, width: '100%' }}>
                    <DataGrid
                        rows={efolderData}
                        columns={columns}
                        getRowId={(row) => row.isAttachment ? `${row.parentId}-${row.entityName}` : row.documentId}
                        checkboxSelection={false}
                        disableSelectionOnClick
                    />
                </Card>
            </Grid>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="upload-modal-title"
                aria-describedby="upload-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="upload-modal-title" variant="h6" component="h2">
                        Upload Document
                    </Typography>
                    <div {...getRootProps()} style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        marginTop: '10px'
                    }}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop some files here, or click to select files</p>
                    </div>
                    <aside>
                        <Typography variant="body1">Files:</Typography>
                        <ul>
                            {files.map((file) => (
                                <li key={file.path}>{file.path} - {file.size} bytes</li>
                            ))}
                        </ul>
                    </aside>
                    <Button variant="contained" color="primary" onClick={handleUpload} sx={{ mt: 2 }}>
                        Upload
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={!!docusignUrl}
                onClose={closeModal}
                aria-labelledby="docusign-modal-title"
                aria-describedby="docusign-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    height: '80%',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="docusign-modal-title" variant="h6" component="h2">
                        DocuSign
                    </Typography>
                    <iframe src={docusignUrl} width="100%" height="100%" title="DocuSign Envelope" />
                    <Button variant="contained" color="secondary" onClick={closeModal} sx={{ mt: 2 }}>
                        Close
                    </Button>
                </Box>
            </Modal>

            {loading && (
                <Modal
                    open
                    aria-labelledby="loading-modal-title"
                    aria-describedby="loading-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <ClipLoader
                            css={css`
                                display: block;
                                margin: 0 auto;
                                border-color: red;
                            `}
                            size={50}
                            color={"#123abc"}
                            loading={loading}
                        />
                        <Typography variant="body2" sx={{ mt: 2 }}>
                            Creating Docusign Envelope...
                        </Typography>
                    </Box>
                </Modal>
            )}

            {loadingUpload && (
                <Modal
                    open
                    aria-labelledby="loading-upload-modal-title"
                    aria-describedby="loading-upload-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <ClipLoader
                            css={css`
                                display: block;
                                margin: 0 auto;
                                border-color: red;
                            `}
                            size={50}
                            color={"#123abc"}
                            loading={loadingUpload}
                        />
                        <Typography variant="body2" sx={{ mt: 2 }}>
                            Uploading documents to Efolder...
                        </Typography>
                    </Box>
                </Modal>
            )}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
            >
                <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Efolder;
